import React, { useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { ModelWrapper } from "../../component/ModelWrapper";
import { WhiteBtn } from "./WhiteBtn";
import { TextArea } from "sr/helpers";
import { Input } from "sr/helpers";
import DropDown from "sr/helpers/ui-components/DropDown.tsx";
import { RadioInput } from "sr/helpers/ui-components/company/RadioInput";
import { FormattedMessage, useIntl } from "react-intl";
import { getWorkorder } from "sr/utils/api/company/workorder/getWorkorder";
import { getUserDetails } from "sr/helpers/functions/getUserDetails";
import { getChecklist } from "sr/utils/api/company/customer/getChecklist";
import { getCustomerLocation } from "sr/utils/api/company/customer/getCustomerLocation";
import { ReactDatePicker } from "sr/helpers/ui-components/ReactDatePicker";
import { ScheduleCalendarBottom } from "../ManageSchedule/components/ScheduleCalendarBottom";
import { useFormik } from "formik";
import { updateWorkorder } from "sr/utils/api/company/workorder/updateWorkorder";
import ContentWithSpinner from "sr/layout/common/ContentWithSpiner";
import { useGet } from "../../Hooks/Api/useGet";
import { getWorkOrderModel } from "sr/utils/api/company/workorder/getWorkOrderModel";
import { updateWorkOrderModel } from "sr/utils/api/company/workorder/updateWorkOrderModel";
import { SuccessMessage } from "sr/helpers/functions/SuccessMessage";
import { LoaderFullScreen } from "sr/layout/common/LoaderFullScreen";
import { useAuth } from "app/pages/module/auth";
import { fetchCustomerData } from "sr/helpers/apiFunctions/fetchCustomerData";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "sr/redux/store";
import { fetchSupervisor } from "sr/redux/reducers/supervisor";
import { Days } from "./Days";
import { getDayname } from "./getDayname";
import { toggleDay } from "./toggleDay";
import differenceInCalendarWeeks from "date-fns/differenceInCalendarWeeks";
import startOfMonth from "date-fns/startOfMonth";
import { getConJobType } from "sr/utils/api/company/contractor/getConJobType";
import { getJobTypeCategory } from "sr/utils/api/getJobTypeCategory";
import workorderSchema from "sr/utils/schemas/company/workOrder/workorderSchema";
import { ReactTimePicker } from "sr/helpers/ui-components/ReactTimePicker";
import { getFeeTransparency } from "sr/utils/api/fee/getFeeTransparency";
import { FeeBreakdownBox } from "app/pages/component/FeeBreakdownBox";
import { Task } from "app/pages/company/Customer/components/Tables/Task";
import TaskForm from "app/pages/company/Customer/components/forms/TaskForm";
export const WorkOrderPopup = (props) => {
  const [type, setType] = useState("");
  const [contractor, setContractor] = useState("");
  const [location, setLocation] = useState("");
  const [selectedCustomer, SetSelectedCustomer] = useState<string>("");
  const [workHours, setWorkHours] = useState();
  const [selectpay, setSelectpay] = useState("");
  const [fixPrice, setFixPrice] = useState("");
  const [checklist, setChecklist] = useState("");
  const intl = useIntl();
  const [companyId, setCompanyId] = useState<string>();
  const [userId, setUserId] = useState();
  const [loader, setLoader] = useState(false);
  const [entryTime, setEntryTime] = useState(null);
  const [exitTime, setExitTime] = useState(null);
  const [description, setDescription] = useState("");
  const [currentDate, setcurrentDate] = useState<any>();
  const [onetimeDate, setOneTimeDate] = useState(new Date());
  const [repeatEvery, setRepeatEvery] = useState();
  const [ends, setEnds] = useState<any>({});
  const [rmdt, setRmdt] = useState();
  const [scheduleType, setScheduleType] = useState("");
  const [recurrence, setRecurrence] = useState();
  const [days, setDays] = useState<any[]>([]);
  const [endsData, setEndsData] = useState<any>({});
  const [cleanerId, setCleanerId] = useState<string>();
  const [status, setStatus] = useState("");
  const [currentDay, setCurrentDay] = useState<any>();
  const [currentweek, setCurrentWeek] = useState<any>();
  const [saveLoader, setSaveLoader] = useState(false);
  const [customer, SetCustomer] = useState<any>();
  const [customerLocationId, setCustomerLocationId] = useState<string>();
  const { userType } = useAuth();
  const [contractors, setContractors] = useState<any>();
  const [workOrderStatus, setWorkOrderStatus] = useState();
  const [title, setTitle] = useState<string>("");
  const [jobtype, setJobType] = useState();
  const [balance, setBalance] = useState(null);
  const [customError, setCustomerError] = useState(null);
  const dispatch = useDispatch<AppDispatch>();
  const supervisorData = useSelector((item: any) => item?.supervisor?.data);
  const [feeTransparency, setFeeTransparency] = useState<any>(null);
  const [feeTransparencyLoading, setFeeTransparencyLoading] = useState(false);
  const [feeTransparencyError, setFeeTransparencyError] = useState<string>("");
  const feeTransparencyReqIdRef = useRef(0);
  const [showNoContractorAlert, setShowNoContractorAlert] = useState(false);
  const [showChecklistEditor, setShowChecklistEditor] = useState(false);
  const [showChecklistTaskForm, setShowChecklistTaskForm] = useState(false);
  const [checklistTaskAdded, setChecklistTaskAdded] = useState(0);
  const checklistTaskFormRef = useRef<{ submitForm: () => void }>(null);

  useEffect(() => {
    const { user_id } = getUserDetails();

    if (userType === "supervisor") {
      setUserId(user_id);
      setCompanyId(supervisorData?.company_id?._id);
    }
    if (userType === "company") {
      setCompanyId(user_id);
      setUserId(user_id);
    }
  }, [userType, supervisorData]);
  useEffect(() => {
    const date = new Date();
    setcurrentDate(date.getDate());
    setCurrentDay(date.getDay());
    const start = startOfMonth(date);
    const week = differenceInCalendarWeeks(date, start) + 1;
    setCurrentWeek(week);
  }, []);

  const initialValueOneTime = {
    id: props?.editId,
    company_id: companyId,
    customer_id: selectedCustomer,
    customer_location_id: location,
    checklist_id: checklist,
    type: type,
    time_for_work_completion: workHours,
    pay_type: selectpay,
    pay_type_rate: fixPrice,
    entry_time: entryTime,
    exit_time: exitTime,
    description: description,
    recurring: scheduleType === "One Time" && false,
    one_time_date: onetimeDate,
    title: title,
    job_type: jobtype,
    workorder_status: "scheduled",
    status: "publish",
  };
  useEffect(() => {
    if (type === "open") {
      setContractor("");
    }
  }, [type]);

  useEffect(() => {
    const amount = Number(fixPrice);
    if (!amount || Number.isNaN(amount) || amount <= 0) {
      setFeeTransparency(null);
      setFeeTransparencyError("");
      setFeeTransparencyLoading(false);
      return;
    }

    const reqId = feeTransparencyReqIdRef.current + 1;
    feeTransparencyReqIdRef.current = reqId;
    setFeeTransparencyLoading(true);
    setFeeTransparencyError("");

    const handle = window.setTimeout(async () => {
      try {
        const res = await getFeeTransparency({
          jobType: "workorder",
          amount,
        });
        if (reqId !== feeTransparencyReqIdRef.current) return;
        if (res?.success === true) {
          setFeeTransparency(res?.data || null);
        } else {
          setFeeTransparency(null);
          setFeeTransparencyError(res?.msg || "Unable to calculate fees.");
        }
      } catch (e: any) {
        if (reqId !== feeTransparencyReqIdRef.current) return;
        setFeeTransparency(null);
        setFeeTransparencyError("Unable to calculate fees.");
      } finally {
        if (reqId === feeTransparencyReqIdRef.current) {
          setFeeTransparencyLoading(false);
        }
      }
    }, 350);

    return () => window.clearTimeout(handle);
  }, [fixPrice]);

  const initialValueRecurring = {
    id: props?.editId,
    company_id: companyId,
    customer_id: selectedCustomer,
    customer_location_id: location,
    checklist_id: checklist,
    cleaner_id: cleanerId,
    type: type,
    time_for_work_completion: workHours,
    pay_type: selectpay,
    pay_type_rate: fixPrice,
    entry_time: entryTime,
    exit_time: exitTime,
    description: description,
    recurring: scheduleType === "Recurring" && true,
    repeat_count: repeatEvery,
    repeat_type: recurrence,
    repeat_month_day_of_week: rmdt === "DayName" ? currentDay : null,
    repeat_month_week: rmdt === "DayName" ? currentweek : null,
    repeat_month_day_of_month: rmdt === "DayNumber" ? currentDate : null,
    repeat_week_day: days,
    ends: ends,
    title: title,
    job_type: jobtype,
    workorder_status: "scheduled",
    status: "publish",
  };

  const { errors, handleSubmit, setFieldValue } = useFormik({
    initialValues:
      props?.page === "Workordermodel"
        ? contractor
          ? { contractor_id: contractor, ...initialValueRecurring }
          : initialValueRecurring
        : contractor
        ? { contractor_id: contractor, ...initialValueOneTime }
        : initialValueOneTime,
    enableReinitialize: true,
    onSubmit: async (values) => {
      if (values?.status !== "draft") {
        // Harendra open next block
        // if(Number(values?.pay_type_rate) > Number(balance?.available_balance)){
        //   setCustomerError({fixprice:'INPUT.VALIDATION.WORKORDER.FIXPRICE'})
        //       return
        // }
      }
      setSaveLoader(true);
      let res;
      if (props?.page === "Workordermodel") {
        res = await updateWorkOrderModel(values);
      } else {
        if(values?.type === "individual") {
          values['is_contract_workorder'] = true
        }
        res = await updateWorkorder(values);
      }
      if (res?.success === true) {
        SuccessMessage("API.SUCCESS.WORKORDER.UPDATE");
        setLoader(false);
        props?.HandleModelByProps(true);
      }
    },
    validationSchema: workorderSchema,
  });
  const endsHandle = (data) => {
    setEnds(data);
  };

  useEffect(() => {
    if (userId && userType === "supervisor") {
      if (!supervisorData) {
        dispatch(fetchSupervisor({ id: userId }));
      }
    }
  }, [userId, userType, dispatch]);
  useEffect(() => {
    const id: Array<any> = supervisorData?.customer_location_ids?.map(
      (item) => item?._id,
    );
    setCustomerLocationId(id?.join());
  }, [supervisorData]);
  useEffect(() => {
    const fetchData = async (id) => {
      try {
        setLoader(true);
        const queryParams = new URLSearchParams();
        if (id) queryParams.append("id", id);
        let res;
        if (props?.page === "Workordermodel") {
          res = await getWorkOrderModel(queryParams);
        } else {
          res = await getWorkorder(queryParams);
        }
        if (res?.success) {
          SetSelectedCustomer(res?.data?.customer_id?._id);
          setJobType(res?.data?.job_type);
          setLocation(res?.data?.customer_location_id?._id);
          setChecklist(res?.data?.checklist_id?._id);
          setContractor(res?.data?.contractor_id?._id);
          setType(res?.data?.type?.toLowerCase());
          setWorkHours(res?.data?.time_for_work_completion);
          setSelectpay(res?.data?.pay_type);
          if (res?.data?.pay_type === "Fixed Rate") {
            setFixPrice(res?.data?.pay_type_rate);
          }
          setEntryTime(res?.data?.entry_time);
          setExitTime(res?.data?.exit_time);
          setDescription(res?.data?.description);
          setTitle(res?.data?.title);
          if (res?.data?.recurring === true) {
            setScheduleType("Recurring");
          } else {
            setScheduleType("One Time");
          }
          if (res?.data?.one_time_date) {
            const newDate = new Date(res?.data?.one_time_date);
            setOneTimeDate(newDate);
          }

          setRepeatEvery(res?.data?.repeat_count);
          setRecurrence(res?.data?.repeat_type);
          setRmdt(res?.data?.repeat_month_day_date);
          setDays(res?.data?.repeat_week_day);
          setEndsData(res?.data?.ends);
          setLoader(false);
          setStatus(res?.data?.status);
          setWorkOrderStatus(res?.data?.workorder_status);
        } else {
          setLoader(false);
        }
      } catch (e) {
        setLoader(false);
      }
    };
    if (props?.editId) {
      fetchData(props?.editId);
    }
  }, [props?.editId]);
  const {
    getData: getLocation,
    loader: LocationLoader,
    data: customerLocations,
  } = useGet();
  const {
    getData: getChecklistData,
    loader: ChecklistLoader,
    data: checklistdetails,
  } = useGet();

  const loadCustomerData = async () => {
    await fetchCustomerData({
      userId: userId,
      userType: userType,
      allData: true,
      customerLocationId: customerLocationId,
      setData: SetCustomer,
    });
  };

  const fetchLocation = async (customerId) => {
    const queryParams = new URLSearchParams();
    if (customerId) queryParams.append("customer_id", customerId.toString());
    queryParams.append("alldata", "true");
    await getLocation(() => getCustomerLocation(queryParams));
  };
  const fetchChecklist = async (customerId) => {
    const queryParams = new URLSearchParams();
    if (customerId) queryParams.append("customer_id", customerId);
    queryParams.append("status", "active");
    queryParams.append("alldata", "true");
    await getChecklistData(() => getChecklist(queryParams));
  };
  useEffect(() => {
    if (userId && userType) {
      if (userType === "supervisor") {
        if (customerLocationId) {
          loadCustomerData();
        }
      } else {
        loadCustomerData();
      }
    }
  }, [userId, customerLocationId]);
  useEffect(() => {
    if (selectedCustomer) {
      fetchLocation(selectedCustomer);
      fetchChecklist(selectedCustomer);
    }
  }, [selectedCustomer]);

  useEffect(() => {
    setShowChecklistEditor(false);
    setShowChecklistTaskForm(false);
  }, [checklist]);

  const handleChecklistTaskAdded = (data) => {
    if (data === "Task") {
      setChecklistTaskAdded((value) => value + 1);
      setShowChecklistTaskForm(false);
    }
  };

  const handleChecklistTaskSubmit = () => {
    if (checklistTaskFormRef.current?.submitForm) {
      checklistTaskFormRef.current.submitForm();
    }
  };

  const loadContractor = async () => {
    const queryParams = new URLSearchParams();
    queryParams.append("job_type", jobtype);
    queryParams.append("company_id", userId);
    queryParams.append("alldata", "true");
    try {
      const res = await getConJobType(queryParams);
      if (res?.success === true) {
        const activeContractors = res?.data?.filter(
          (item) => item?.contractor_id?.status === "active",
        );
        setContractors(activeContractors);
      }
    } catch (e) {}
  };
  useEffect(() => {
    if (jobtype) {
      loadContractor();
    }
  }, [jobtype]);

  const HandleDraft = () => {
    setFieldValue("status", "draft");
    handleSubmit();
  };

  useEffect(() => {
    if (userId) {
      // Harendra open this
      // fetchBalance({userId:companyId, workorderId:props?.editId, setData:setBalance, setLoader:setLoader})
    }
  }, [userId]);

  const [jobTypes, setJobTypes] = useState([]);
  useEffect(() => {
    const fetchJobType = async () => {
      try {
        const res = await getJobTypeCategory();
        if (res?.success === true) {
          setJobTypes(res?.data);
        }
      } catch (e: any) {}
    };
    fetchJobType();
  }, []);

  useEffect(() => {
    if (contractor) {
      const Rate = contractors?.find(
        (item: any) => item?.contractor_id?._id === contractor
      )?.rate;
      if (Rate && workHours) {
        setFixPrice(String(parseInt(workHours) * Number(Rate)));
      }
    }
  }, [workHours, contractor]);

  useEffect(() => {
    if (!showChecklistEditor) {
      return;
    }

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = originalOverflow;
    };
  }, [showChecklistEditor]);

  return (
    <ModelWrapper
      rounded="rounded-[10px]"
      background="bg-[#00000099]"
      position="fixed"
      opacity="opacity-100"
      topPosition="top-[10%]"
      rightPosition="inset-0"
      width="w-[50%] mx-auto"
      showModal={props?.showModal || props?.editId}
      HandleModelByProps={props.HandleModelByProps}
    >
      {saveLoader && <LoaderFullScreen />}
      <ContentWithSpinner loader={loader} height="h-80">
        <div className="flex justify-end space-x-2 py-3 px-3 mb-3 border-b border-solid border-slate-200">
          <WhiteBtn
            onClick={() => {
              HandleDraft();
            }}
            title={
              <FormattedMessage
                id="RECRUITER.SCHEDULEWORKORDER.EDIT.BUTTON.DRAFT"
                defaultMessage="Draft"
              />
            }
          ></WhiteBtn>

          <WhiteBtn
            onClick={() => {
              if (type?.toLowerCase() === "individual" && !contractor) {
                setShowNoContractorAlert(true);
                return;
              }
              handleSubmit();
            }}
            title={
              <FormattedMessage
                id="RECRUITER.SCHEDULEWORKORDER.EDIT.BUTTON.PUBLISH"
                defaultMessage="Publish"
              />
            }
          ></WhiteBtn>

          <WhiteBtn
            onClick={() => props.HandleModelByProps(false)}
            title={
              <FormattedMessage
                id="RECRUITER.SCHEDULEWORKORDER.EDIT.BUTTON.CANCEL"
                defaultMessage="Cancel"
              />
            }
          ></WhiteBtn>
        </div>
        <div className="px-5">
          <Input
            error={errors?.title}
            label={intl.formatMessage({
              id: "RECRUITER.SCHEDULEWORKORDER.INPUT.WORKORDER.TITLE",
              defaultMessage: "Title",
            })}
            onChange={(e) => setTitle(e.target.value)}
            type="text"
            inputClass="rounded-lg"
            labelClass="mt-2 text-black"
            InputDivClass="mt-0 w-26 pr-2 pb-2"
            placeholder={intl.formatMessage({
              id: "RECRUITER.SCHEDULEWORKORDER.INPUT.WORKORDER.TITLE.PLACEHOLDER",
            })}
            value={title}
          />
          <DropDown
            error={errors?.job_type}
            labelClass="text-base"
            value={jobtype}
            label={
              <FormattedMessage
                id="CLEANER.JOBS.FILTER.JOBTYPE"
                defaultMessage="Job Type"
              />
            }
            dropdowndiv="mt-3"
            onChange={(e) => setJobType(e.target.value)}
            className="rounded-lg"
          >
            <option value="">
              <FormattedMessage
                id="CLEANER.PROFILE.EMPLOYMENT.SELECT.JOBTYPE.TITLE"
                defaultMessage="Select Job Type"
              />
            </option>
            {jobTypes?.map((item, index) => (
              <option key={index} value={item?.value}>
                <FormattedMessage id={item?.label}></FormattedMessage>
              </option>
            ))}
          </DropDown>
          <DropDown
            error={errors?.customer_id}
            labelClass="text-base"
            value={selectedCustomer}
            label={
              <FormattedMessage
                id="RECRUITER.WORKORDER.FILTER.CUSTOMER.TITLE"
                defaultMessage="Customer"
              />
            }
            dropdowndiv="mt-3"
            onChange={(e) => SetSelectedCustomer(e.target.value)}
            className="rounded-lg"
          >
            <option value="">
              <FormattedMessage
                id="RECRUITER.WORKORDER.FILTER.SELECTCUSTOMER"
                defaultMessage="Select Customer"
              />
            </option>
            {customer?.map((item, index) => (
              <option key={index} value={item?.id}>
                {item?.name}
              </option>
            ))}
          </DropDown>
          <DropDown
            error={errors?.customer_location_id}
            labelClass="text-base"
            value={location}
            label={
              <FormattedMessage
                id="RECRUITER.WORKORDER.FILTER.LOCATION"
                defaultMessage="Location"
              />
            }
            dropdowndiv="mt-1 pr-2 pb-2"
            onChange={(e) => setLocation(e.target.value)}
            className="rounded-lg"
          >
            <option value="">
              <FormattedMessage
                id="RECRUITER.WORKORDER.FILTER.SELECT.LOCATION"
                defaultMessage="Select Location"
              />
            </option>
            {customerLocations?.map((item, index) => (
              <option value={item?.id}>{item?.name}</option>
            ))}
          </DropDown>
          <div className="flex items-start gap-3">
            <div className="flex-1">
              <DropDown
                error={errors?.checklist_id}
                labelClass="text-base"
                value={checklist}
                label={
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.INPUT.CHECKLIST.TITLE"
                    defaultMessage="Checklist"
                  />
                }
                dropdowndiv="mt-1 pr-2 pb-2"
                onChange={(e) => setChecklist(e.target.value)}
                className="rounded-lg"
              >
                <option value="">
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.INPUT.CHECKLIST.SELECT"
                    defaultMessage="Select Checklist"
                  />
                </option>
                {checklistdetails?.map((item, index) => (
                  <option key={item?.id || index} value={item?.id}>
                    {item?.name}
                  </option>
                ))}
              </DropDown>
            </div>
            <button
              type="button"
              disabled={!checklist}
              onClick={() => setShowChecklistEditor(true)}
              className={`mt-7 rounded-lg px-4 py-2 font-bold ${
                checklist
                  ? "bg-[#ff39b3] text-white hover:border-[#0078ae]"
                  : "cursor-not-allowed bg-neutral-200 text-neutral-500"
              }`}
            >
              Edit Checklist
            </button>
          </div>
          <div className="flex items-center mt-3">
            <div className="flex items-centerspace-x-3">
              <label className=" inline-block" htmlFor="Type">
                <FormattedMessage
                  id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.TYPE.TITLE"
                  defaultMessage="Type"
                />
              </label>
              <RadioInput
                name="Type"
                value="open"
                label={
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.TYPE.OPEN"
                    defaultMessage="Open"
                  />
                }
                checked={type?.toLowerCase() === "open"}
                onChange={() => setType("open")}
              ></RadioInput>
              <RadioInput
                name="Type"
                value="individual"
                label={
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.TYPE.INDIVIDUAL"
                    defaultMessage="Individual"
                  />
                }
                checked={type?.toLowerCase() === "individual"}
                onChange={() => setType("individual")}
              ></RadioInput>
            </div>
            {type?.toLowerCase() === "individual" && (
              <DropDown
                labelClass="text-base"
                value={contractor}
                label={
                  <div className="flex items-center gap-1">
                    <FormattedMessage
                      id="RECRUITER.SCHEDULEWORKORDER.INPUT.CONTRACTOR.TITLE"
                      defaultMessage="Contractor"
                    />

                    <div className="group relative flex items-center">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        className="size-4 cursor-pointer text-gray-500"
                      >
                        <path
                          fillRule="evenodd"
                          d="M18 10a8 8 0 1 1-16 0 8 8 0 0 1 16 0Zm-7-4a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM9 9a.75.75 0 0 0 0 1.5h.253a.25.25 0 0 1 .244.304l-.459 2.066A1.75 1.75 0 0 0 10.747 15H11a.75.75 0 0 0 0-1.5h-.253a.25.25 0 0 1-.244-.304l.459-2.066A1.75 1.75 0 0 0 9.253 9H9Z"
                          clipRule="evenodd"
                        />
                      </svg>

                      <div className="absolute left-0 top-6 z-20 w-80 scale-0 rounded bg-gray-800 p-3 text-xs text-white shadow-lg transition-transform duration-150 group-hover:scale-100">
                        Not seeing your contractor? Contractors must be assigned
                        the Job Type selected for this work order to appear
                        here.
                        <br />
                        <br />
                        For more information:{" "}
                        <a
                          href="https://support.janijobs.com/hc/en-us/articles/49970501767067-Assigning-Job-Types-to-Contractor"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="underline text-blue-300"
                        >
                          Assigning Job Types to Contractor
                        </a>
                      </div>
                    </div>
                  </div>
                }
                dropdowndiv="mt-1 w-26 pr-2 pb-2"
                onChange={(e) => setContractor(e.target.value)}
                className="rounded-lg"
              >
                <option value="">
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.INPUT.CONTRACTOR.SELECT"
                    defaultMessage="Select Contractor"
                  />
                </option>

                {contractors?.map((item, index) => (
                  <option key={index} value={item?.contractor_id?._id}>
                    {item?.contractor_id?.first_name}{" "}
                    {item?.contractor_id?.last_name} ${item?.rate}/hr
                  </option>
                ))}
              </DropDown>
            )}
          </div>
          <Input
            error={errors?.time_for_work_completion}
            label={
              <FormattedMessage
                id="RECRUITER.SCHEDULEWORKORDER.INPUT.TITLE"
                defaultMessage="Time for work completion"
              />
            }
            onChange={(e) => setWorkHours(e.target.value)}
            type="number"
            inputClass="rounded-lg"
            labelClass="mt-2 text-black"
            InputDivClass="mt-0 w-26 pr-2 pb-2"
            placeholder={intl.formatMessage({
              id: "RECRUITER.SCHEDULEWORKORDER.INPUT.TITLE.PLACEHOLDER",
              defaultMessage: "Number of hours",
            })}
            value={workHours}
          />
          <div className="flex items-center mt-3 space-x-3">
            <Input
              inputClass="rounded-lg [appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
              label={
                <FormattedMessage
                  id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.PAYTYPE.FIXPRICE.INPUT.PLACEHOLDER"
                  defaultMessage="Enter the fixed rate"
                />
              }
              onChange={(e) => setFixPrice(e.target.value)}
              type="number"
              labelClass="mt-2 text-black"
              InputDivClass="mt-0 w-[50%] pr-2 pb-2"
              prefix="$"
              value={fixPrice}
              error={errors?.pay_type_rate || customError?.fixprice}
            />
            {/* Harendra open on this 794 till */}
            {/* <div className="flex space-x-3 items-center h-11">
                    <div><span className="">Wallet Balance: </span>${Number(balance?.available_balance)?.toFixed(2)}</div>
      
                    </div> */}
          </div>
          <div className="mt-3">
            <div className="flex items-start justify-between gap-3">
              <div>
                <div className="text-sm font-medium text-neutral-900">
                  Fee breakdown
                </div>
              </div>
            </div>
            {feeTransparencyLoading ? (
              <div className="text-sm text-neutral-500 mt-2">Calculating…</div>
            ) : feeTransparencyError ? (
              <div className="text-sm text-red-500 mt-2">
                {feeTransparencyError}
              </div>
            ) : feeTransparency ? (
              <FeeBreakdownBox
                className="mt-3"
                rows={[
                  {
                    label: "Service amount",
                    value: Number(feeTransparency?.amount || 0),
                  },
                  {
                    label: "Service fee",
                    value: Number(
                      feeTransparency?.job_provider_fee_amount || 0,
                    ),
                  },
                ]}
                totalLabel="Total payable"
                totalValue={Number(
                  feeTransparency?.job_provider_paid_amount || 0,
                )}
              />
            ) : (
              <div className="text-sm text-neutral-500 mt-2">
                Enter a rate to see fees.
              </div>
            )}
          </div>
          <div className="flex items-center w-full mt-3">
            <ReactTimePicker
              error={errors?.entry_time}
              onChange={(value: string) => setEntryTime(value)}
              label={
                <FormattedMessage
                  id="RECRUITER.SCHEDULEWORKORDER.INPUT.ENTRYTIME"
                  defaultMessage="Entry Time"
                />
              }
              value={entryTime}
              inputClass="rounded-lg"
              labelClass="mt-2 text-black"
              InputDivClass="mt-0 pr-2 pb-2"
              placeholder={
                <FormattedMessage
                  id="RECRUITER.SCHEDULEWORKORDER.INPUT.ENTRYTIME"
                  defaultMessage="Entry Time"
                />
              }
            ></ReactTimePicker>
            <ReactTimePicker
              error={errors?.exit_time}
              onChange={(value) => setExitTime(value)}
              value={exitTime}
              label={
                <FormattedMessage
                  id="RECRUITER.SCHEDULEWORKORDER.INPUT.EXITTIME"
                  defaultMessage="Exit Time"
                />
              }
              inputClass="rounded-lg"
              labelClass="mt-2 text-black"
              InputDivClass="mt-0 pr-2 pb-2"
              placeholder={
                <FormattedMessage
                  id="RECRUITER.SCHEDULEWORKORDER.INPUT.EXITTIME"
                  defaultMessage="Exit Time"
                />
              }
            ></ReactTimePicker>
          </div>

          <TextArea
            rows={3}
            placeholder={intl.formatMessage({
              id: "RECRUITER.SCHEDULEWORKORDER.INPUT.DESCRIPTION.PLACEHOLDER",
              defaultMessage: "Write your note here...",
            })}
            className="flex-1 p-2.5 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:border-[#0078ae] focus:shadow-inputshadow outline-0"
            onChange={(e) => setDescription(e.target.value)}
            value={description}
          ></TextArea>

          {props?.page === "Workordermodel" ? (
            <>
              {/* <div className='flex items-center pb-3 mb-3 space-x-3'>
                    <label className='' htmlFor='ScheduleType'><FormattedMessage id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.SCHEDULETYPE" defaultMessage="Type" /></label>
<RadioInput name="ScheduleType" value="One Time" label={<FormattedMessage id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.SCHEDULETYPE.ONETIME" defaultMessage="One Time" />} checked={scheduleType === 'One Time'} onChange={() => setScheduleType('One Time')}></RadioInput>
<RadioInput name="ScheduleType" value="Recurring" label={<FormattedMessage id="RECRUITER.SCHEDULEWORKORDER.RADIOINPUT.SCHEDULETYPE.RECURRING" defaultMessage="Recurring" />} checked={scheduleType === 'Recurring'} onChange={() => setScheduleType('Recurring')}></RadioInput>
                </div> */}
              {/* {scheduleType=== 'One Time' && 
<ReactDatePicker onChange={(date)=> setOneTimeDate(date)} selected={onetimeDate} label={<FormattedMessage id="RECRUITER.SCHEDULEWORKORDER.INPUT.ENTERDATE" defaultMessage="Enter Date" />} inputClass="rounded-lg" labelClass="mt-2 text-black" InputDivClass="mt-0 w-26 pr-2 pb-2" type="date" placeholder="Enter date"></ReactDatePicker>
} */}
              {scheduleType === "Recurring" && (
                <>
                  <div className="flex space-x-2 items-center">
                    <Input
                      onChange={(e) => setRepeatEvery(e.target.value)}
                      value={repeatEvery}
                      topinputdiv="w-16"
                      label={
                        <FormattedMessage
                          id="RECRUITER.SCHEDULEWORKORDER.INPUT.REPEATEVERY"
                          defaultMessage="Repeat every"
                        />
                      }
                      inputClass="rounded-lg"
                      labelClass="mt-0 text-black"
                      InputDivClass="mt-0 pr-2 flex space-x-2 items-center"
                      type="number"
                    ></Input>
                    <DropDown
                      value={recurrence}
                      dropdowndiv="mt-0"
                      onChange={(e) => setRecurrence(e.target.value)}
                      className="rounded-lg"
                    >
                      <option value="">
                        <FormattedMessage
                          id="RECRUITER.SCHEDULEWORKORDER.INPUT.SELECT.RECURRENCE"
                          defaultMessage="Select Recurrence"
                        />
                      </option>
                      <option value="weekly">Weekly</option>
                      <option value="monthly">Monthly</option>
                    </DropDown>
                  </div>
                  {recurrence !== "Daily" && recurrence != "" && (
                    <div className="py-3">
                      {recurrence === "weekly" ? (
                        <div className="mb-4">
                          <div>
                            <p className="pb-2 ">
                              <FormattedMessage
                                id="RECRUITER.SCHEDULEWORKORDER.INPUT.REPEATON"
                                defaultMessage="Repeat on"
                              />
                            </p>
                            <div className="flex space-x-2">
                              {Days?.map((day, index) => (
                                <span
                                  key={index}
                                  onClick={() =>
                                    toggleDay(day.id, days, setDays)
                                  }
                                  className={`${
                                    days?.includes(day.id)
                                      ? "bg-[#ff39b3] font-bold text-white"
                                      : "bg-white border border-neutral-200"
                                  } cursor-pointer rounded-full h-10 w-10 flex justify-center items-center`}
                                >
                                  {day.name}
                                </span>
                              ))}
                            </div>
                          </div>
                          <ScheduleCalendarBottom
                            endsHandle={endsHandle}
                            ends={endsData}
                          />
                        </div>
                      ) : null}
                      {recurrence === "monthly" && (
                        <div className="mb-4">
                          <div className="flex">
                            <DropDown
                              value={rmdt}
                              dropdowndiv="mt-0"
                              className="rounded-lg"
                              onChange={(e) => setRmdt(e.target.value)}
                            >
                              <option
                                value={"DayNumber"}
                              >{`Monday on day ${currentDate}`}</option>
                              <option value={"DayName"}>
                                Monthly on the last {getDayname(currentDay)}
                              </option>
                            </DropDown>
                          </div>
                          <ScheduleCalendarBottom endsHandle={endsHandle} />
                        </div>
                      )}
                    </div>
                  )}
                </>
              )}{" "}
            </>
          ) : (
            <>
              <ReactDatePicker
                onChange={(date) => setOneTimeDate(date)}
                selected={onetimeDate}
                minDate={new Date()}
                label={
                  <FormattedMessage
                    id="RECRUITER.SCHEDULEWORKORDER.INPUT.SCHEDULEDATE"
                    defaultMessage="Schedule Date"
                  />
                }
                inputClass="rounded-lg"
                labelClass="mt-2 text-black"
                InputDivClass="mt-0 w-26 pr-2 pb-2"
                type="date"
                placeholder="Enter date"
              ></ReactDatePicker>
            </>
          )}
          {showNoContractorAlert && (
            <ModelWrapper
              noCancel={true}
              HandleModelByProps={() => setShowNoContractorAlert(false)}
              rightPosition="inset-0"
              rounded="rounded-[10px]"
              background="bg-[#00000099]"
              opacity="opacity-100"
              showModal={showNoContractorAlert}
              width="w-[40%] mx-auto"
              position="fixed"
              topPosition="top-[20%]"
            >
              <div className="flex items-center justify-between rounded-t">
                <button className="p-1 ml-auto bg-transparent border-0 text-black opacity-1 float-right text-3xl leading-none font-semibold outline-none focus:outline-none">
                  <span
                    onClick={() => setShowNoContractorAlert(false)}
                    className="bg-transparent text-black opacity-1 h-6 w-6 text-2xl block outline-none focus:outline-none"
                  >
                    ×
                  </span>
                </button>
              </div>
              <p className="text-lg mx-6 mb-6 text-center">
                You must have contractors added before you can schedule work
                orders. Create a job post to hire a contractor or invite an
                existing contractor in the contractor menu.
              </p>
              <div className="flex justify-center pb-6">
                <WhiteBtn
                  onClick={() => setShowNoContractorAlert(false)}
                  mainClass="w-40 flex justify-center"
                  title="OK"
                ></WhiteBtn>
              </div>
            </ModelWrapper>
          )}
          {showChecklistEditor && createPortal(
            <ModelWrapper
              noCancel={true}
              HandleModelByProps={() => setShowChecklistEditor(false)}
              rightPosition="inset-0"
              rounded="rounded-[10px]"
              background="bg-[#00000099]"
              opacity="opacity-100"
              showModal={showChecklistEditor}
              width="w-[75%] mx-auto"
              position="fixed"
              topPosition="top-[8%]"
              zIndexClass="z-[1110]"
              overlayZIndexClass="z-[1100]"
            >
              <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
                <h3 className="text-2xl font-semibold">Edit Checklist</h3>
                <button
                  className="p-1 text-3xl leading-none text-black"
                  onClick={() => setShowChecklistEditor(false)}
                  type="button"
                >
                  x
                </button>
              </div>
              <div className="max-h-[70vh] overflow-y-auto p-6">
                <div className="overflow-x-auto rounded-[20px] border border-neutral-200">
                  <Task
                    checklistId={checklist}
                    taskadded={checklistTaskAdded}
                    getTasks={() => null}
                  />
                </div>

                {showChecklistTaskForm && (
                  <div className="mt-6 rounded-[20px] border border-neutral-200 p-5">
                    <TaskForm
                      ref={checklistTaskFormRef}
                      checklistId={checklist}
                      customerId={selectedCustomer}
                      dataAddedHandle={handleChecklistTaskAdded}
                    />
                  </div>
                )}

                <div className="mt-5 flex justify-end gap-3">
                  {showChecklistTaskForm ? (
                    <>
                      <WhiteBtn
                        onClick={() => setShowChecklistTaskForm(false)}
                        title="Cancel"
                      />
                      <WhiteBtn
                        onClick={handleChecklistTaskSubmit}
                        title="Save Task"
                      />
                    </>
                  ) : (
                    <WhiteBtn
                      onClick={() => setShowChecklistTaskForm(true)}
                      title="Add Task"
                    />
                  )}
                </div>
              </div>
            </ModelWrapper>,
            document.body,
          )}
        </div>
      </ContentWithSpinner>
    </ModelWrapper>
  );
};
